import * as React from 'react';
import { message } from 'antd';
import CreateStoreForm from '../components/CreateStoreForm';
import { metaSelectors } from '@ui/store/meta';
import { connect } from 'react-redux';
import * as actions from '../services/actions';
import { compressImage } from '../../../utils/helpers';

interface StateToProps {
  cities: any[];
  factories: any[];
  markets: any[];
  collections: any[];
}

interface DispatchToProps {
  createStore: (store: any, file: any) => void;
  createMarket: (market: any) => void;
}

class CreateStore extends React.PureComponent<StateToProps & DispatchToProps> {
  state = { file: null, section: 'store' };

  handleCreateStore = () => {
    const { form } = this.formRef.props;
    const { file, section } = this.state;

    form.validateFields((err: any, values: any) => {
      const { createStore, createMarket } = this.props;
      if (err) {
        return;
      }

      if (section === 'market') {
        createMarket(values);
      } else {
        createStore(values, file);
      }
    });
  };

  handleValuesChange = (changedValues: any) => {
    const { file } = changedValues;
    if (file) {
      const isImage = file.file.type.match('image.*');
      if (!isImage) {
        message.error('Файл должен быть КАРТИНКОЙ');
        return;
      }
      const isLt500k = file.file.size / 1024 / 1024 < 0.5;
      if (!isLt500k) {
        const reader = new FileReader();
        reader.readAsDataURL(file.file);
        reader.onload = function (e) {
          const img = new Image();
          img.onload = () => {
            compressImage(img, file.file.type, file.file.name, (f: any) => {
              f.uid = `rc-upload-${f.lastModified}-2`;
              file.fileList = [f];
              file.file = f;
            });
          };
          // @ts-ignore
          img.src = e.target.result;
        };
      }
      this.setState({ file });
    }
  };

  setSection = (e: any) => {
    this.setState({ section: e.target.value });
  };

  saveFormRef = (formRef: any) => {
    this.formRef = formRef;
  };
  private formRef: any;

  render() {
    const { cities, factories, markets, collections } = this.props;
    const { file } = this.state;
    return (
      <div className="create-store-form">
        <CreateStoreForm
          // @ts-ignore
          onCreate={this.handleCreateStore}
          wrappedComponentRef={this.saveFormRef}
          cities={cities}
          factories={factories}
          markets={markets}
          onFieldsChange={this.handleValuesChange}
          collections={collections}
          file={file}
        />
      </div>
    );
  }
}

const mapStateToProps = (state: any): StateToProps => ({
  cities: metaSelectors.getCities(state),
  factories: metaSelectors.getFactories(state),
  markets: metaSelectors.getMarkets(state),
  collections: metaSelectors.getCollections(state),
});

const mapDispatchToProps = {
  createStore: actions.createStoreRequested,
  createMarket: actions.createMarketRequested,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateStore);



// WEBPACK FOOTER //
// ./src/scenes/CreateStore/containers/CreateStore.tsx